import { render } from "./TrainerCardV2.vue?vue&type=template&id=26239ea5&scoped=true"
import script from "./TrainerCardV2.vue?vue&type=script&lang=js"
export * from "./TrainerCardV2.vue?vue&type=script&lang=js"

import "./TrainerCardV2.vue?vue&type=style&index=0&id=26239ea5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26239ea5"]])

export default __exports__